module.exports = __webpack_public_path__ + "static/img/0006.1b023aa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/usdt2/0006.png
// module id = i20+
// module chunks = 1